import React from 'react'
import "./Responsive.css";
import { FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCircleExclamation} from '@fortawesome/free-solid-svg-icons';

const Responsive = () => {
  return (
    <div className="responsive">
        <div className="responsive__text">
            <div className="responsive__text__head">Error </div>
            <div className="responsive__text__body">We currently do not support this screen size!<br></br>Please resize your screen or visit us on a different device!</div>
            <FontAwesomeIcon className="responsive__text__icon" icon={faCircleExclamation}/>
        </div>
    </div>
  )
}

export default Responsive